import store from '@/store'

/**
 * 权限指令
 * 用法: v-permission="'order:create'"
 * 如果没有权限，元素将被移除
 */
export default {
  inserted(el, binding) {
    const { value } = binding
    
    if (value) {
      const permissionCodes = store.state.permissionCodes || []
      const hasPermission = permissionCodes.includes(value)
      
      if (!hasPermission) {
        // 移除元素
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      console.warn('v-permission 指令需要传入权限码')
    }
  },
  
  update(el, binding) {
    // 权限变更时重新检查（如果元素还存在）
    const { value } = binding
    
    if (value) {
      const permissionCodes = store.state.permissionCodes || []
      const hasPermission = permissionCodes.includes(value)
      
      if (!hasPermission && el.parentNode) {
        // 移除元素
        el.parentNode.removeChild(el)
      }
    }
  }
}
